import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './loader.styles.scss';
import { getText } from 'helpers/i18n';

import imgLoadingAnimation from 'images/loading-animation.gif';
import imgLoadingDelivery from 'images/loading-animation-delivery.gif';
import imgLoadingSpinner from 'images/loading-thin-24.svg';

export default class Loader extends Component {
    render() {
        const { theme, className } = this.props;

        let loaderImage;
        let loaderTheme;
        const loaderText = window.Checkout && window.Checkout.text ? getText('loader_text') : '';

        switch (theme) {
            case 'animation':
                loaderImage = imgLoadingAnimation;
                loaderTheme = theme;
                break;
            case 'delivery':
                loaderImage = imgLoadingDelivery;
                loaderTheme = theme;
                break;
            default:
                loaderImage = imgLoadingSpinner;
                loaderTheme = 'spinner';
        }

        return (
            <div className={`ikea-loader ikea-loader-${loaderTheme} ${className}`}>
                <img className={`ikea-loader__image ikea-loader__image-${loaderTheme}`} src={loaderImage} alt={loaderText} />
            </div>
        );
    }
}

Loader.propTypes = {
    theme: PropTypes.string,
    className: PropTypes.string,
};
